import { create } from 'zustand'

const LANGUAGES = ['es', 'en', 'cn'];

function getInitialLangage() {
  const saved = localStorage.getItem('langage');
  return LANGUAGES.includes(saved) ? saved : 'es';
}

export const useLangagesStore = create((set) => ({
  langage: getInitialLangage(),
  setLangage: (newLangage) => {
    if (LANGUAGES.includes(newLangage)) {
      localStorage.setItem('langage', newLangage);
      set({ langage: newLangage });
    }
  },
}))